import { intl } from 'i18n';
import * as React from 'react';
import messages from '../displayMessages';
import { NavLink } from 'react-router-dom';
import footerMessages from 'ui/components/Footer/displayMessages';
import { MessageDescriptor } from 'react-intl';

interface Props {
    type: 'sign-in' | 'sign-up';
    clickOnMessage?: MessageDescriptor;  /// Used on sign-in
    clickOnMessageValues?: any;
}

export const TermsAndPolicyComponent: React.FunctionComponent<Props> = (props) => {
    return (
        <div className='auth-terms-policy-text-component'>
        {props.type === 'sign-in' && props.clickOnMessage &&
            <>
                {intl.formatMessage(messages.lxAuthSignInPolicyMsgComplete, {
                    msg: intl.formatMessage(props.clickOnMessage, props.clickOnMessageValues),
                    terms: <a href='https://about.labxchange.org/tos'>{intl.formatMessage(footerMessages.footerTermsOfService)}</a>,
                    privacy: <a href='https://about.labxchange.org/privacy-notice'>{intl.formatMessage(footerMessages.footerPrivacyPolicy)}</a>
                })}
            </>
        }
        {props.type === 'sign-up' &&
            <>
                {intl.formatMessage(messages.lxAuthSignUpPolicyMsgComplete, {
                    terms: <a href='https://about.labxchange.org/tos'>{intl.formatMessage(footerMessages.footerTermsOfService)}</a>,
                    privacyNotice: <a href='https://about.labxchange.org/privacy-notice'>{intl.formatMessage(footerMessages.footerPrivacyPolicy)}</a>
                })}
            </>
        }
        </div>
    );
};
